import type { SUMMARY_ROUTE } from 'cpool-constants';
import { LOANREQUEST_DEFAULT_STATUS, LOANREQUEST_STATUSES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import type { LeadsFilter } from './shared/types';

type Arguments = {
    filters?: LeadsFilter;
    position?: number;
    route?: SUMMARY_ROUTE;
};

export const schemaLoanRequestResolver_GetCounts = z.object({
    [LOANREQUEST_DEFAULT_STATUS.ACTIVE]: z.number(),
    [LOANREQUEST_DEFAULT_STATUS.ALL]: z.number(),
    // unfortunately, we have to list all statuses here as there is no keyed object in zod
    [LOANREQUEST_STATUSES.INITIAL]: z.number().optional(),
    [LOANREQUEST_STATUSES.CANCELED]: z.number().optional(),
    [LOANREQUEST_STATUSES.IN_PROGRESS]: z.number().optional(),
    [LOANREQUEST_STATUSES.OFFER_AT_BANK]: z.number().optional(),
    [LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER]: z.number().optional(),
    [LOANREQUEST_STATUSES.APPROVED]: z.number().optional(),
});

export type SchemaLoanRequestResolver_GetCounts = z.infer<typeof schemaLoanRequestResolver_GetCounts>;

export type LoanRequestResolver_GetCounts = Resolver<Arguments, SchemaLoanRequestResolver_GetCounts>;
